import React from 'react';
import styles from './flex.module.scss';
import {Alignment} from '../../enums/alignment.ts';

interface OwnProps {
    children: React.ReactNode;
    alignment?: Alignment;
    verticalAlignment?: Alignment;
}

export function FlexRow({children, alignment, verticalAlignment}: OwnProps) {
    const flexClass = () => {
        switch (alignment) {
            case Alignment.Center:
                return 'center';
            case Alignment.End:
                return 'flex-end';
            case Alignment.Start:
                return 'flex-start';
            default:
                return 'space-between';
        }
    };

    const verticalAlignmentClass = () => {
        switch (verticalAlignment) {
            case Alignment.End:
                return 'flex-end';
            case Alignment.Start:
                return 'flex-start';
            case Alignment.Center:
            default:
                return 'center';
        }
    };

    return (
        <div className={styles.flex_row} style={{justifyContent: flexClass(), alignItems: verticalAlignmentClass()}}>
            {children}
        </div>
    );
}
